export interface FulltextSearchStoryOutputApiModel {
    id: number;
}

export class FulltextSearchStoryOutputApiModel {
    constructor() { }
}